import * as THREE from "three";

import vertexShader from "./shaders/DomeVertexShader.glsl";
import fragmentShader from "./shaders/DomeFragmentShader.glsl";

class DomeMaterial extends THREE.MeshBasicMaterial {
  constructor(parameters = {}) {
    super(parameters);

    this.onBeforeCompile = (shader) => {
      if (vertexShader) {
        shader.vertexShader = vertexShader;
      }
      if (fragmentShader) {
        shader.fragmentShader = fragmentShader;
      }

      // extend uniforms
      shader.uniforms = {
        ...shader.uniforms,
        offset: {
          type: THREE.Vector3,
          //value: new THREE.Vector3(6, 0, -11.5),
          value: new THREE.Vector3(0, 0, -11.5),
        },
      };
    };
  }
}

export default DomeMaterial;
